import React from 'react';
import css from '@emotion/css';
import { gray4 } from 'styles/global_defaults/colors';

type LineDividerProps = {
  className?: string,
  shouldHide?: boolean,
};

const LineDivider = (props: LineDividerProps) => {
  const {
    className,
    shouldHide = false,
  } = props;

  const styles = css`
    height: 1px;
    width: ${100}px;
    background-color: ${gray4};
  `;

  if (shouldHide) {
    return null;
  }

  return (
    <div css={styles} className={className} />
  );
};

export default LineDivider;
